import {
  RiDeleteBinLine,
  RiErrorWarningLine,
  RiPencilLine,
} from "react-icons/ri";
import MemoryButton from "./MemoryButton";
import { formatMemoryDate } from "./formatMemoryDate";
import css from "./memory.module.scss";

const REVIEW_FALLBACK =
  "The original source does not clearly establish this fact.";
const HIDDEN_REASON =
  "The assistant no longer uses this fact. Its source message was forgotten or is no longer available. Save it again to use it.";

export default function MemoryCard({
  fact,
  index,
  busy,
  onEdit,
  onForget,
  children,
}) {
  const review = fact.qualityStatus === "needs_review";
  return (
    <article
      className={`${css.shell} ${css.card} ${review ? css.cardReview : ""}`}
      style={{ "--mem-index": Math.min(index, 8) }}
    >
      <div className={`${css.core} ${css.cardCore}`}>
        <div className={css.cardMeta}>
          {fact.category && (
            <span className={`${css.chip} ${css.chipAccent}`}>
              {fact.category}
            </span>
          )}
          {fact.status && (
            <span className={`${css.chip} ${review ? css.chipReview : ""}`}>
              {fact.status}
            </span>
          )}
          {fact.pendingSubmissionId && <p role="status">A correction is pending. The assistant is not using this memory.</p>}
        {fact.hidden && (
            <span className={`${css.chip} ${css.chipReview}`}>hidden</span>
          )}
          <span className={css.cardDate}>
            {formatMemoryDate(fact.observedAt)}
          </span>
        </div>

        <p
          className={`${css.cardText} ${fact.hidden ? css.cardTextHidden : ""}`}
        >
          {fact.text}
        </p>

        {fact.hidden && (
          <p className={css.cardReason}>
            <RiErrorWarningLine aria-hidden="true" />
            {HIDDEN_REASON}
          </p>
        )}

        {review && (
          <p className={css.cardReason}>
            <RiErrorWarningLine aria-hidden="true" />
            {fact.qualityReason || REVIEW_FALLBACK}
          </p>
        )}

        <div className={css.cardActions}>
          <MemoryButton
            size="xs"
            icon={<RiPencilLine />}
            disabled={Boolean(busy) || Boolean(fact.pendingSubmissionId)}
            onClick={onEdit}
          >
            Edit
          </MemoryButton>
          <MemoryButton
            size="xs"
            variant="danger"
            icon={<RiDeleteBinLine />}
            loading={busy === fact.id}
            disabled={Boolean(busy) && busy !== fact.id}
            onClick={onForget}
          >
            Forget
          </MemoryButton>
          <span className={css.cardActionsSpacer} />
          {children}
        </div>
      </div>
    </article>
  );
}
